<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{
              $t('productLocation.location')
            }}</label>
            <input v-model="model.location_name_en" disabled type="text" class="form-control"
              :class="{ 'is-invalid': errors.has('location_name_en') }" />
            <div class="invalid-feedback ts-text-xs" v-if="errors.has('location_name_en')">
              {{ errors.first('location_name_en') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{
              $t('productLocation.productNameEn')
            }}</label>
            <input v-model="model.product_name_en" disabled type="text" class="form-control"
              :class="{ 'is-invalid': errors.has('product_name_en') }" />
            <div class="invalid-feedback ts-text-xs" v-if="errors.has('product_name_en')">
              {{ errors.first('product_name_en') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('productLocation.storageLocation')
            }}</label>
            <a-select v-model.number.trim="model.warehouse_storage_id" :options="storageList" showSearch :filterOption="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " class="ts-w-full" :class="{ 'is-invalid': errors.has('requested_by') }" placeholder="Select"
              @search="handleSearch" :loading="storage_searching"></a-select>
            <div class="invalid-feedback ts-text-xs" v-if="errors.has('warehouse_storage_id')">
              {{ errors.first('warehouse_storage_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button v-if="isUpdate" color="primary" @click.prevent="onUpdate" :waiting="waiting">{{ $t('update')
            }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'warehourseForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      waiting_new: false,
      storage_searching: '',
      storages: [],
      model: {
        product_location_id: 0,
        location_id: 0,
        product_id: null,
        location_name_en: null,
        product_name_en: null,
        warehouse_storage_id: null,
      },
    }
  },
  async created() {
    this.loading = true
    await this.setEditData()
    await this.getStorages()
    this.loading = false
  },
  computed: {
    ...mapState('product/location', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    storageList() {
      if (this.storages) {
        return this.storages.map((el) => ({
          value: el.warehouse_storage_id,
          label: el.storage_name_en,
        }))
      }
      return []
    },
  },
  methods: {
    ...mapActions('product/location', ['getStorage']),
    handleSearch: debounce(async function (value) {
      this.storage_searching = true
      await this.getStorage({
        location_id: this.model.location_id,
        warehouse_storage_id: value ? null : this.model.warehouse_storage_id,
        search: value,
      })
        .then((response) => {
          this.storages = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.storage_searching = false
        })
    }, 800),
    async getStorages() {
      this.loading = true
      await this.getStorage({
        location_id: this.model.location_id,
        warehouse_storage_id: this.model.warehouse_storage_id,
      })
        .then((response) => {
          this.storages = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('product/location/update', {
          id: this.model.product_location_id,
          data: this.model,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.product_location_id = this.edit_data.product_location_id
        this.model.product_id = this.edit_data.product_id
        this.model.location_id = this.edit_data.location_id
        this.model.location_name_en = this.edit_data.location_name_en
        this.model.product_name_en = this.edit_data.product_name_en
        this.model.warehouse_storage_id = this.edit_data.warehouse_storage_id
      }
    },
  },
}
</script>
